import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputFieldWrapper } from '@components-shared/forms/FieldLabel';
import { IFormField } from '@components-shared/forms/formField.interface';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import { Switch as AntdSwitch } from 'antd';
import styles from './switcher.module.scss';

type ISwitchProps = {
  valid: boolean;
  onChange: (state: boolean) => void;
  value: boolean;
} & IFormField;

export const Switcher = ({
  className,
  name,
  tooltip,
  title,
  required,
  validationMessage,
  hintMessage,
  valid,
  onChange,
  value,
}: ISwitchProps) => {
  const { i18n } = useTranslation();

  return (
    <InputFieldWrapper
      name={name}
      title={title}
      tooltip={tooltip}
      required={required}
      valid={valid}
      validationMessage={validationMessage}
      className={className}>
      <div className={styles.switcher__wrapper}>
        {hintMessage && <span className={styles.switcher__hint}>{i18n.t(hintMessage as KeyMapKeys)}</span>}
        <AntdSwitch checked={value} onChange={onChange} />
      </div>
    </InputFieldWrapper>
  );
};
